// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for validating Hospital Config response body.
 * @see #/components/schemas/HospitalConfig - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface HospitalConfig {
    /**
     * Name of config in lower case
     *
     */
    name: string;
    /**
     * Value of config
     *
     */
    value: string;
    /**
     * Description of the config
     *
     */
    description?: string | null;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for HospitalConfig
 */
export namespace HospitalConfig {
    /**
     * HospitalConfig Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * Name of config in lower case
         * @type string (`dataFormat` is missing)
         */
        name: string;
        /**
         * Value of config
         * @type string (`dataFormat` is missing)
         */
        value: string;
        /**
         * Description of the config
         * @type string (`dataFormat` is missing)
         */
        description?: string | null;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * HospitalConfig DTO
     * Transforms HospitalConfig model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend HospitalConfig model */
        static toModel(obj: HospitalConfig): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend HospitalConfig model */
        static toApi(obj: Model): HospitalConfig {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as HospitalConfig;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
